import GameIdButton from "components/Host/GameIdButton";
import { useGameContext } from "GameContext";

import { useWebSocket } from "WebSocketContext";

import { useEffect, useState } from "react";

import PillButton from "components/General/PillButton";
import PillSelectorMenu from "components/General/PillSelectorMenu";

export default function GameSettings() {
  const { isConnected, playerId, socket } = useWebSocket();
  const {
    gameId,
    setGameId,
    setHostId,

    setGameTimer,
    setVoteTimer,
    setYearCount,
  } = useGameContext() as any;

  function createRoom() {
    setHostId(playerId);

    if (!socket) {
      return;
    }

    socket?.send(JSON.stringify({
      kind: "CreateGame",
      hostId: playerId,
      gameInviteCode: gameId,
    }))
  }

  function generateRoomCode(hostId: number, length = 4) {
    const randomFactor = Math.floor(Math.random() * 36 ** length);
    const combined = hostId + randomFactor;
    
    // Convert to base-36
    const base36Hash = combined.toString(36).toUpperCase();
    
    return base36Hash.padStart(length, '0').substring(0, length);
  }

  useEffect(() => {
    if ( playerId > 0) {
      setGameId(generateRoomCode(playerId))
    }
  }, [playerId])

  useEffect(() => {
    if (playerId && gameId && socket) {
      createRoom()
    }
  }, [gameId, socket, playerId])

  const [selectedWetland, setSelectedWetland] = useState(0);
  const wetlandOptions = [
    "Camargue",
    "Mekong Delta",
    "Everglades",
    "Pantanal",
    "Venice",
    "Sundarbans",
    "Okavango Delta",
    "Aukstumala",
    "Kerala backwaters"
  ]

  const [selectedGameTimer, setSelectedGameTimer] = useState(0);
  const [selectedTownhallTimer, setSelectedTownhallTimer] = useState(1);
  const timerOptions = [
    "5 mins",
    "7 mins",
    "10 mins",
    "20 mins",
    "60 mins",
  ]
  const timerValues = [
    5 * 60,
    7 * 60,
    10 * 60,
    20 * 60,
    60 * 60,
  ]

  // console.log(gameTimer);
  // console.log(voteTimer);

  const [selectedRound, setSelectedRound] = useState(0);
  const roundCountOptions = [ 5, 7, 10 ]

  return (
    <div className="flex flex-col gap-2 p-2 overflow-y-auto h-full">
      <div className="flex flex-col">
        <label className="text-center">Keyword</label>
        <GameIdButton gameId={gameId}/>
      </div>

      <PillSelectorMenu
        title={"Wetlands"}
        options={wetlandOptions}
        selectedOption={selectedWetland}
        setSelectedOption={setSelectedWetland}
      />

      <PillSelectorMenu
        title={"Game Timer"}
        options={timerOptions}
        selectedOption={selectedGameTimer}
        setSelectedOption={(i:number) => {
          setSelectedGameTimer(i)
          setGameTimer(timerValues[i]);
        }}
      />

      <PillSelectorMenu
        title={"Townhall Timer"}
        options={timerOptions}
        selectedOption={selectedTownhallTimer}
        setSelectedOption={(i:number) => {
          setSelectedTownhallTimer(i)
          setGameTimer(timerValues[i]);
        }}
      />

      <PillSelectorMenu
        title={"Round Count"}
        options={roundCountOptions}
        selectedOption={selectedRound}
        setSelectedOption={(i: number) => {
          setSelectedRound(i);
          setYearCount(roundCountOptions[i])
        }}
      />
    </div>

  )
}
